import NavigationBar from "@/components/navigation-bar/NavigationBar";
import TabBar from "@/components/tab-bar/TabBar";
import InputText from "@/components/input-text/InputText";
import InputButton from "@/components/input-button/InputButton";
import Loader from "@/components/loader/Loader";
import SettingsHeader from "@/components/settings-header/SettingsHeader";
import {Entity, EntityOption, EntityService, TimeSlotLengthDropdown} from "@/services/entity.service";
import InputCheckbox from "@/components/input-checkbox/InputCheckbox";
import InputTimePicker from "@/components/input-time-picker/InputTimePicker";
import InputDropdown from "@/components/input-dropdown/InputDropdown";
import OpeningHoursSelector from "@/components/opening-hours-selector/OpeningHoursSelector"
import OpeningHoursViolations from '../../../components/opening-hours-violations/OpeningHoursViolations'
import router from "@/router";
import {ScreenLoader} from "@/utils/loading.util";
import {Constants} from "@/constants";
import {GroupDropdown, GroupService} from "@/services/group.service";
import {SortedTable, SortLink} from 'vue-sorted-table'
import {BookingOption, BookingOptionDropDown, BookingService} from "@/services/booking.service";
import Card from '../../../components/card/Card'
import moment from "moment";
import {Location, LocationService, OpeningHours} from "@/services/location.service";

export default {
    name: "Entity",
    components: {
        Loader,
        TimeSlotLengthDropdown,
        InputDropdown,
        InputTimePicker,
        InputCheckbox,
        InputButton,
        InputText,
        OpeningHoursSelector,
        OpeningHoursViolations,
        SettingsHeader,
        TabBar,
        NavigationBar,
        SortedTable,
        SortLink,
        Card
    },

    data() {
        return {
            entity: new Entity(),
            location: new Location(),
            groupId: undefined,
            screenLoader: new ScreenLoader(),
            edit: true,
            timeSlotLengths: [],
            days: 0,
            time: "00:00",
            disableTime: true,
            openingTime: "05:00:00",
            closingTime: "23:00:00",
            sortedOptions: [],
            bookingOptionsDropdown: [],
            groupsDropdown: [],
            bookingOptions: [],
            selectedBookingOption: '',
            selectedGroup: '',
            showOptionsCard: false,
            selectedEntityOption: new EntityOption(),
            openingHoursInput: new OpeningHours(),
            openingHours: {},
            showOpeningHours: false,
            locationFinishedLoading: false,
            violations: Array,
            showViolations: false,
        }
    },

    mounted: async function() {
        this.groupId = this.$route.query.groupId
        await this.getLocationInformation(this.groupId)


        if(this.$route.query.id == "undefined") {
            this.edit = false
            this.openingHours = this.location.openingHours
            this.showOpeningHours = true
        } else {
            await this.getEntity(this.$route.query.id)
        }

        this.getGroups()
        await this.getOptions(this.location.id)
    },

    methods: {
        doClear(reference) {
            this.entity[reference] = ''
        },

        doSave: async function(){
            this.setBookingWindow()
            if (this.entity.name != undefined) {

                // convert the opening hours
                this.openingHours = LocationService.convertOpeningHours(this.openingHoursInput)
                this.entity.openingHours = this.openingHours
                // since the entity can close earlier or start later than the location we should correct this in the openingHours
                for (let d = 0; d < 7; d++) {
                    if (this.entity.timeSlotStartTime != this.location.timeSlotStartTime ) {
                        this.entity.openingHours.defaultWeek[d].times.unshift({
                            from: "00:00",
                            to: this.entity.timeSlotStartTime.slice(0, 5)
                        })
                    }
                    if (this.entity.timeSlotEndTime != this.location.timeSlotEndTime) {
                        this.entity.openingHours.defaultWeek[d].times.push({
                            from: this.entity.timeSlotEndTime.slice(0, 5),
                            to: "23:59"
                        })
                    }
                }

                // since the entity can close earlier or start later than the location we should correct this in the exceptions
                for (let i = 0; i < this.entity.openingHours.exceptions.length; i ++) {
                    this.entity.openingHours.exceptions[i].times.unshift({from: "00:00", to: this.entity.timeSlotStartTime.slice(0,5)})
                    this.entity.openingHours.exceptions[i].times.push({from: this.entity.timeSlotEndTime.slice(0,5), to: "00:00"})
                }
                // find the violating bookings
                let violations = await EntityService.findViolatingBookings(this.location, this.entity, this.entity.openingHours)
                if (violations.length == 0) {
                    await this.performAction()
                } else {
                    this.showViolations = !this.showViolations
                    this.violations = violations
                }
            } else {
                for (const ref in this.$refs) {
                    if (this.$refs[ref] != undefined) {
                        this.$refs[ref].checkForError()
                    }
                }
            }
        },

        performAction: async function() {
            try{
                if (!this.edit) {
                    let response = await EntityService.postEntity(this.entity, this.groupId)
                    this.handleMutateEntityResponse(response, "The entity has been successfully created")
                } else {
                    let response = await EntityService.putEntity(this.entity, this.groupId)
                    this.handleMutateEntityResponse(response, "The entity has successfully been updated")
                }
            } catch (error) {
                this.handleMutateEntityFailureResponse(error.errorCode, error.message)
            }
        },

        doCancel(){
            router.push(`/settings/groups/${this.$route.query.groupId}`)
        },

        toggleActive() {
            this.entity.active = !this.entity.active
        },

        toggleExternal() {
            this.entity.external = !this.entity.external
        },

        toggleReminder() {
            this.entity.notifyMissingLicensePlate = !this.entity.notifyMissingLicensePlate
        },

        toggleAutoApprove() {
            this.entity.autoApproveBooking = !this.entity.autoApproveBooking
        },

        toggleOverride() {
            this.entity.overrideDockStatusCheck = !this.entity.overrideDockStatusCheck
        },


        handleMutateEntityResponse(response, message) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: response.status, message: message })
            router.push(`/settings/groups/${this.$route.query.groupId}`)
        },

        handleMutateFormulaResponse(response, message) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: response.status, message: message })
        },

        handleMutateEntityFailureResponse(code, message) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: code, message: message.errorAtEntry })
        },

        changeTimeSlotLength(id){
            this.entity.timeSlotLengthInMinutes = Number(this.timeSlotLengths[id].value)
        },

        fillTimeSlots(timeSlotLength){
            let id = 0
            for (let i = timeSlotLength; i <= 240; i += timeSlotLength) {
                if (Number.isInteger(1440/i) && i > 0) {
                    this.timeSlotLengths.push(new TimeSlotLengthDropdown(id, i))
                    id++
                }
            }
        },

        /**
         * Function that determines the bookingWindowInMinutes calculated as follows:
         * (closing time - booking window time) + number of preceeding days
         * example: closing time  18:00
         * booking window set to 1 day before at 20:00
         *
         * upfront booking window:
         * closing time - booking window time = -120 minutes
         * -120 + 1 * 24*60 = 1320 min --> 22h
         * Hence booking should be placed 22h before closing date of the selected date
         */
        setBookingWindow() {
            if (this.days == 0) {
                this.entity.upfrontBookingWindowInMinutes = 0
            } else {
                let closingHoursDate = new Date()
                closingHoursDate.setHours(Number(this.entity.timeSlotEndTime.split(':')[0]), Number(this.entity.timeSlotEndTime.split(':')[1]), 0)
                let bookingWindowDate = new Date()
                bookingWindowDate.setHours(Number(this.time.split(':')[0]), Number(this.time.split(':')[1]), 0)
                let diff = closingHoursDate.getTime() - bookingWindowDate.getTime()

                let bookingWindow = (diff / 1000) / 60 // calc difference and convert to minutes
                bookingWindow = bookingWindow + this.days * 24 * 60

                this.entity.upfrontBookingWindowInMinutes = bookingWindow
            }
        },

        getEntity: async function(id){
            let response = await EntityService.getEntityById(id)
            this.entity = response
            this.openingHours = this.entity.openingHours
            this.showOpeningHours = true // only show the openinghours when it is loaded
            this.openingTime = this.entity.timeSlotStartTime
            this.closingTime = this.entity.timeSlotEndTime
            this.sortedOptions = this.entity.bookingOptions
            if (response.upfrontBookingWindowInMinutes != 0) {
                // to calculate the number of days we have to calculate the number of absolute days between the window startdate and the end date
                let endMoment = moment().set({
                    hours: Number(this.entity.timeSlotEndTime.split(':')[0]),
                    minutes: Number(this.entity.timeSlotEndTime.split(':')[1]),
                    seconds: 0, milliseconds: 0
                })

                let startMoment = moment(endMoment).subtract(this.entity.upfrontBookingWindowInMinutes, 'minutes').startOf('day')
                this.days = Math.abs(endMoment.diff(startMoment, 'days')) // calculate the number of different days



                let windowEndTime = moment()
                // calculate the end time of the window
                windowEndTime.add(this.days, 'days')
                    .set({
                        hours: Number(this.entity.timeSlotEndTime.split(':')[0]),
                        minutes: Number(this.entity.timeSlotEndTime.split(':')[1]),
                        seconds: 0, milliseconds: 0
                    })
                let windowStartTime = moment(windowEndTime)
                // translate the end date to the start date
                windowStartTime.subtract(this.entity.upfrontBookingWindowInMinutes, 'minutes')

                this.time = windowStartTime.toDate().toTimeString().slice(0, 5)
            }
        },

        getLocationInformation: async function(groupId) {
            let response = await GroupService.getGroup(groupId)
            if (response.location != undefined)  {
                this.location = await LocationService.getLocation(response.location.id)
                this.locationFinishedLoading = true
                this.fillTimeSlots(this.location.timeSlotLengthInMinutes)
            } else {
                await this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: "404", message: "this group does not have a location" })
                router.push(`/settings/groups/${this.$route.query.groupId}`)
            }

        },

        getOptions: async function(locationId) {
            try {
                const options = await BookingService.getBookingOptions(locationId)
                this.bookingOptions = options.map(o => new BookingOption(o))
                this.bookingOptionsDropdown = options.map(o => new BookingOptionDropDown(o.id, o.name))
            }catch(error) {
                this.handleMutateEntityFailureResponse(error.errorCode, error.message)
            }
        },

        getGroups: function() {
          const groups = this.location.groups;
          this.groupsDropdown = groups.map(g => new GroupDropdown(g))
          this.selectedGroup = this.groupsDropdown.find(g => g.id === this.groupId).value

        },

        addBookingOptionToEntity: async function(id) {
            this.selectedBookingOption = this.bookingOptionsDropdown.find(o => o.id == id).value
            try {
                let option = new EntityOption(id, undefined)
                let response = await EntityService.postBookingOption(this.entity.id, option)
                await this.getEntity(this.entity.id)
                this.handleMutateFormulaResponse(response.code, "Booking option added to entity")
            }catch(error) {
                this.handleMutateEntityFailureResponse(error.errorCode, error.message)
            }
            this.getOptions(this.location.id)
        },

        changeGroup: function (id) {
            const group = this.groupsDropdown.find(g => g.id === id)
            this.selectedGroup = group.value
            this.groupId = group.id
        },

        deleteOptionFromEntity: async function(id) {
            try {
                let response = await EntityService.deleteOption(this.entity.id, id)
                await this.getEntity(this.entity.id)
                this.handleMutateFormulaResponse(response.code, "Booking option removed from entity")
            }catch(error) {
                this.handleMutateEntityFailureResponse(error.errorCode, error.message)
            }
            this.getOptions(this.location.id)
        },

        toggleOptionCard: async function(optionId) {
            try {
                if (optionId != undefined) {
                    let response = await EntityService.getEntityOptionById(this.entity.id, optionId)
                    this.selectedEntityOption = new EntityOption(response.id, response.type, response.timeSlotLengthFormulas)
                }
            } catch (error) {
                this.handleMutateEntityFailureResponse(error.errorCode, error.message)
            }
            this.showOptionsCard = !this.showOptionsCard
        },

        updateFormula: async function() {
            this.showOptionsCard = !this.showOptionsCard
            let entityOption = this.selectedEntityOption
            delete entityOption.type
            try {
                let response = await EntityService.putBookingOption(this.entity.id, entityOption)
                await this.getEntity(this.entity.id)
                this.handleMutateFormulaResponse(response.code, "Sucesfully updated formula")
            } catch (error) {
                this.handleMutateEntityFailureResponse(error.errorCode, error.message)
            }
            this.selectedEntityOption = undefined
            this.getOptions()
        }
    }

}
